import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const NotFound = () => (
  <AlertDialog open={true}>
    <AlertDialogContent>
      <AlertDialogHeader className="font-medium tracking-tighter text-left">
        <AlertDialogTitle>Sorry, we can't find that menu</AlertDialogTitle>
      </AlertDialogHeader>
      <p className="whitespace-pre-line text-left text-sm text-muted-foreground">
        {`Please try to scan the QR code on your table again.

        If the error persists, please contact staff.`}
      </p>
    </AlertDialogContent>
  </AlertDialog>
);

export default NotFound;
